import axios from "axios"
import store from "../store"
import router from "../router"

// 创建axios实例
var Axios = axios.create({
    baseURL: process.env.VUE_APP_DORM,
    timeout: 1000 * 60, // 10s超时
    // headers: { 'Content-Type': 'application/json;charset=UTF-8' }
})

// 请求拦截
Axios.interceptors.request.use(
    // 请求发送前
    config => {
        return config
    }
)

// 添加响应拦截器
Axios.interceptors.response.use(
    response => {
        return response.data
    },
    error => {
        if(error.response.status == 401) {      // 退出登入
            store.commit("User/REMOVE_NICK_NAME")
            if(router.currentRoute.name !== 'login') {
                router.replace({
                    path: 'login',
                    query: { 
                        redirect: "/post" /* router.currentRoute.fullPath */
                    }    // 将跳转的路由path作为参数，登录成功后跳转到该路由
                })
            }
        } else if(error.response.status == 422) {
            alert(error.response.data.errors[0].msg)
        }
        console.log(error)
        return Promise.reject(error.response)
    }
)

export default Axios